<template>
    <div id="Essaywriting" @mouseup="selectChange">
        <div class="form_part">
            <div class="part_top"><img class="top_icon" :src="appTempalte.app_icon" alt="">{{appTempalte.app_name}}</div>
            <div class="part_content">
                <el-scrollbar class="write_scrollbar">
                    <div style="padding-right:20px">
                        <el-form ref="form" label-width="55px" label-position="left">
                            <template v-for="(item,index) in formList">
                                <div v-if="item.input_type=='input'&&index==0" style="margin-bottom: 22px;">
                                    <el-input :placeholder="item.placeholder"  v-model="item.value" :maxlength="item.max" show-word-limit></el-input>
                                </div>
                                <el-form-item prop="theme" v-if="item.input_type=='input'&&index>0" :label="item.name+'：'" style="margin-left: 0px;">
                                    <el-input :placeholder="item.placeholder"  v-model="item.value" :maxlength="item.max" show-word-limit></el-input>
                                </el-form-item>
                                <div v-if="item.input_type=='textarea'&&index==0" style="margin-bottom: 22px;">
                                    <el-input :placeholder="item.placeholder" type="textarea"  :rows="item.rows" v-model="item.value" :maxlength="item.max" show-word-limit></el-input>
                                </div>
                                <el-form-item prop="theme" v-if="item.input_type=='textarea'&&index>0" :label="item.name+'：'" style="margin-left: 0px;">
                                    <el-input :placeholder="item.placeholder" type="textarea"  :rows="item.rows" v-model="item.value" :maxlength="item.max" show-word-limit></el-input>
                                </el-form-item>

                                <el-form-item prop="theme" v-if="item.input_type=='number'" :label="item.name+'：'">
                                    <el-input-number style="width:100%;" :placeholder="item.placeholder"  v-model="item.value" :max="item.max"></el-input-number>
                                </el-form-item>
                            
                                <el-form-item prop="theme" v-if="item.input_type=='select'" :label="item.name+'：'">
                                    <el-select v-model="item.value" :placeholder="item.placeholder" style="width:100%;">
                                        <el-option :label="opt.value" :value="opt.value" v-for="opt in item.data_list" :key="opt.value"></el-option>
                                    </el-select>
                                </el-form-item>
                            </template>
                            <el-form-item label-width="0" style="clear:both;">
                                <el-button style="width:120px;float:left;" @click="resetForm">重置</el-button>
                                <el-button v-if="!saveLoading" style="width:220px;height:40px;float:right;" type="primary" @click="submitForm"><img class="write_icon" src="./img/img_icon_26.png">开始写</el-button>
                                <transition name="spread">
                                    <div class="writing_wrap" v-if="saveLoading">
                                        <div class="writing_btn">
                                            <img class="writing_icon" src="./img/img_icon_110.gif" alt="">
                                            <div class="writing_text"><span class="text_span">正在写...</span></div>
                                            <img class="stop_icon" @click="stopAiWrite" src="./img/img_icon_104.png" alt="">
                                        </div>
                                    </div>
                                </transition>
                            </el-form-item>
                        </el-form>
                        <div class="example_part">
                            <div class="example_title">
                                <div class="title_text">实例演示</div>
                                <router-link class="nav_item" to="/membership">
                                    <div class="get_vip">
                                            <img class="vip_icon" src="./img/img_icon_31.png" alt="">
                                            <div class="vip_text">会员限时优惠中···</div>
                                            <img class="more_icon" src="./img/img_icon_32.png" alt="">
                                    </div>
                                </router-link>
                            </div>
                            <div class="example_list">
                                <div class="list_item" v-for="exam in exam_list" :key="exam.id">{{exam.title}}<img @click="useTemplateDemo(exam)" class="use_icon" src="./img/img_icon_33.png"></div>
                            </div>
                        </div>
                    </div>
                </el-scrollbar>
            </div>
        </div>
        <div class="edit_part">
            <div class="part_top">
                <div class="write_title"><img class="top_icon" :src="appTempalte.app_icon" alt="">{{cur_article.question||"无标题···"}}</div>
                <div class="auto_save"><div v-show="autoSaving"><img class="top_icon" src="./img/img_icon_35.png" alt="">实时自动保存中…</div></div>
                <div class="top_tool">
                    <div class="tool_btn" @click="showUpload"><img class="btn_icon" src="./img/img_icon_36.png" alt=""></div>
                    <div class="tool_btn" @click="doActionRow('star')"><img class="btn_icon" src="./img/img_icon_02.png" alt=""></div>
                    <div class="tool_btn" @click="showShare"><img class="btn_icon" src="./img/img_icon_37.png" alt=""></div>
                    <div class="tool_btn">
                        <el-popover placement="bottom-end" :offset="10" width="360" trigger="hover">
                            <div class="doc_panel">
                                <div class="doc_panel_title">最近文档</div>
                                <el-table :data="recent_doc_list" height="370" style="width: 100%" @row-click="selectDoc">
                                    <el-table-column label="文档" :show-overflow-tooltip="true">
                                        <template slot-scope="scope">
                                            <div class="doc_name"><img class="doc_icon" :src="scope.row.app_icon" alt="">{{ scope.row.question }}</div>
                                            <div class="doc_create_name">{{ scope.row.update_time }}</div>
                                        </template>
                                    </el-table-column>
                                    <el-table-column prop="real_name" width="80" align="right" label="作者">
                                        <template slot-scope="scope">
                                            <div style="padding-bottom:23px;">{{ scope.row.real_name }}</div>
                                        </template>
                                    </el-table-column>
                                </el-table>
                            </div>
                            <img class="btn_icon" slot="reference" src="./img/img_icon_38.png" alt="">
                        </el-popover>
                    </div>
                </div>
            </div>
            <div class="editor_wrapper">
                <quillEditorVue @changeContent="richTextChange" @changeToolBar="changeToolBar" ref="quillEditor" :content="edit_content"></quillEditorVue>
                <transition name="slide">
                    <div class="editor_slider" v-show="showSlide">
                        <template v-if="slideDefault">
                            <div class="slider_top default_top">
                                <img class="close_icon" @click="closeSlide" src="./img/img_icon_51.png" alt="">
                                <img class="logo_icon" src="./img/img_icon_50.png" alt="">
                                <div class="default_title">懒人办公智能Ai写作机器人</div>
                                <div class="default_desc">一款集改写、翻译等功能齐全的万能Ai写作助手</div>
                            </div>
                            <div class="slide_content default_content">
                                <div class="content_tips"><span class="tips_text">查看记录</span></div>
                                <div class="type_list">
                                    <div class="type_item" @click="getRecord('gaixie','改写')">改写</div>
                                    <div class="type_item" @click="getRecord('kuoxie','扩写')">扩写</div>
                                    <div class="type_item" @click="getRecord('jianxie','简写')">简写</div>
                                    <div class="type_item" @click="getRecord('xuxie','续写')">续写</div>
                                    <div class="type_item" @click="getRecord('jiangchong','降重')">降重</div>
                                    <div class="type_item" @click="getRecord('jiaodui','校对')">校对</div>
                                    <div class="type_item" @click="getRecord('runse','润色')">润色</div>
                                    <div class="type_item" @click="getRecord('fanyi','翻译')">翻译</div>
                                </div>
                                <div class="type_line_two">
                                    <div class="type_item" @click="getRecord('fenxi','全文分析')">全文分析</div>
                                    <div class="type_item" @click="getRecord('keypoint','核心问题')">核心问题</div>
                                    <div class="type_item" @click="getRecord('wenti','相关问题')">相关问题</div>
                                </div>
                            </div>
                        </template>
                        <template v-else>
                            <div class="slider_top">
                                <div class="slider_title">
                                    <img class="logo_icon" src="./img/img_icon_50.png" alt="">
                                    <div class="title_text" @click="showSlideDefault">懒人办公 · {{action_name}}</div>
                                    <img class="close_icon" @click="closeSlide" src="./img/img_icon_51.png" alt="">
                                </div>
                                <div class="top_input">
                                    <input class="input_ele" type="text" placeholder="可以输入更详细的命令" v-model="question">
                                    <img class="send_icon" src="./img/img_icon_52.png" alt="" @click="sendChatMsg">
                                </div>
                            </div>
                            <div class="slide_content">
                                <el-scrollbar class="write_scrollbar">
                                    <div class="msg_list" v-if="msgList.length">
                                        <div class="msg_item" v-for="(msg, idx) in msgList" :key="idx">
                                            <div class="msg_source">
                                                <div class="source_main">
                                                    <div class="msg_desc">{{ msg.question }}</div>
                                                    <div class="msg_quote" v-if="msg.quote">{{ msg.quote }}</div>
                                                </div>
                                                <div class="msg_head"><img class="head_img" src="./img/img_icon_50.png" alt=""></div>
                                            </div>
                                            <div class="msg_content"><div class="tip_loading" v-if="msg.loading&&!msg.answer"><img class="ai_loading" src="./img/ai_loading.gif" alt=""><span>思考中...</span></div>{{ msg.answer }}</div>
                                            <div class="msg_operation">
                                                <button :disabled="msg.loading" class="msg_btn" @click.stop="replaceSelect(msg.answer)"><img class="btn_icon" src="./img/img_icon_53.png" alt="">替换选中</button>
                                                <button :disabled="msg.loading" class="msg_btn" @click.stop="insertAfter(msg.answer)"><img class="btn_icon" src="./img/img_icon_54.png" alt="">导入之后</button>
                                                <button :disabled="msg.loading" class="msg_btn" @click="copytext(msg.answer)"><img class="btn_icon" src="./img/img_icon_42.png" alt="">复制</button>
                                                <button class="msg_btn" v-if="msg.loading" @click="stopReply(msg)"><img class="btn_icon" src="./img/img_icon_104.png" alt="">暂停</button>
                                                <button class="msg_btn" v-else @click="stopReply(msg)"><img class="btn_icon" src="./img/img_icon_51.png" alt="">弃用</button>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="empty_msg" v-else>
                                        <img class="empty_icon" src="./img/img_icon_109.png" alt="">
                                        <div class="empty_text">暂无{{action_name}}记录</div>
                                    </div>
                                </el-scrollbar>
                            </div>
                        </template>
                    </div>
                </transition>
            </div>
            <div class="part_footer">
                <div class="count_info">
                    <div class="word_count">字数：{{ ai_write_count }}字</div>
                    <div class="left_count">今日剩余字数：{{ profileData.today_left_words - ai_write_count >= 0 ? profileData.today_left_words - ai_write_count : 0 }}字</div>
                </div>
                <div class="footer_btns">
                    <button class="btn_item" @click="expand('fenxi','全文分析')"><img class="btn_icon" src="./img/fenxi.png" alt="">全文分析</button>
                    <button class="btn_item" @click="expand('keypoint','核心观点')"><img class="btn_icon" src="./img/keypoint.png" alt="">核心观点</button>
                    <button class="btn_item" @click="expand('wenti','相关问题')"><img class="btn_icon" src="./img/wenti.png" alt="">相关问题</button>
                    <button class="btn_item" @click="copyArticle"><img class="btn_icon" src="./img/img_icon_42.png" alt="">复制</button>
                    <el-popover placement="top" trigger="hover">
                        <ul class="dropdown_list">
                            <li class="dropdown_item" v-for="item in exportTypeList" :key="item.type" @click="fileExport(item.type)"><img :src="require('./img/img_icon_'+item.icon+'.png')" alt="">{{ item.name }}</li>
                        </ul>
                        <button class="btn_item" slot="reference"><img class="btn_icon" src="./img/img_icon_43.png" alt="">导出<span class="split_line"></span><img class="btn_icon down_icon" src="./img/img_icon_44.png" alt=""></button>
                    </el-popover>
                </div>
            </div>
            <div class="selection_menu" v-show="menuShow" :style="{'left':siteX+'px','top':siteY+'px'}">
                <div class="menu_btn" @click="setFont('bold')">
                    <svg viewBox="0 0 18 18">
                        <path class="ql-stroke" d="M5,4H9.5A2.5,2.5,0,0,1,12,6.5v0A2.5,2.5,0,0,1,9.5,9H5A0,0,0,0,1,5,9V4A0,0,0,0,1,5,4Z"></path>
                        <path class="ql-stroke" d="M5,9h5.5A2.5,2.5,0,0,1,13,11.5v0A2.5,2.5,0,0,1,10.5,14H5a0,0,0,0,1,0,0V9A0,0,0,0,1,5,9Z"></path>
                    </svg>
                </div>
                <div class="menu_btn" @click="setFont('italic')">
                    <svg viewBox="0 0 18 18">
                        <line class="ql-stroke" x1="7" x2="13" y1="4" y2="4"></line>
                        <line class="ql-stroke" x1="5" x2="11" y1="14" y2="14"></line>
                        <line class="ql-stroke" x1="8" x2="10" y1="14" y2="4"></line>
                    </svg>
                </div>
                <div class="menu_btn" @click="setFont('underline')">
                    <svg viewBox="0 0 18 18">
                        <path class="ql-stroke" d="M5,3V9a4.012,4.012,0,0,0,4,4H9a4.012,4.012,0,0,0,4-4V3"></path>
                        <rect class="ql-fill" height="1" rx="0.5" ry="0.5" width="12" x="3" y="15"></rect>
                    </svg>
                </div>
                <div class="menu_btn line" @click="setFont('strike')">
                    <svg viewBox="0 0 18 18">
                        <line class="ql-stroke ql-thin" x1="15.5" x2="2.5" y1="8.5" y2="9.5"></line>
                        <path class="ql-fill" d="M9.007,8C6.542,7.791,6,7.519,6,6.5,6,5.792,7.283,5,9,5c1.571,0,2.765.679,2.969,1.309a1,1,0,0,0,1.9-.617C13.356,4.106,11.354,3,9,3,6.2,3,4,4.538,4,6.5a3.2,3.2,0,0,0,.5,1.843Z"></path>
                        <path class="ql-fill" d="M8.984,10C11.457,10.208,12,10.479,12,11.5c0,0.708-1.283,1.5-3,1.5-1.571,0-2.765-.679-2.969-1.309a1,1,0,1,0-1.9.617C4.644,13.894,6.646,15,9,15c2.8,0,5-1.538,5-3.5a3.2,3.2,0,0,0-.5-1.843Z"></path>
                    </svg>
                </div>
                <!-- <div class="menu_btn" @click="expand('gaixie','改写')">改写<img class="hot_icon" src="./img/img_icon_97.png" alt=""></div> -->
                <div class="menu_btn expand">改写<img class="hot_icon" src="./img/img_icon_97.png" alt=""><img class="slide_icon" src="./img/img_icon_111.png">
                    <div class="slide_wrap">
                        <div class="slide_item" @click="expand('gaixie','改写')">基础</div>
                        <div class="slide_item" @click="expand('gaixie_ql','改写')">强力</div>
                        <div class="slide_item" @click="expand('gaixie_xs','改写')">学术</div>
                        <div class="slide_item" @click="expand('gaixie_gw','改写')">古文</div>
                    </div>
                </div>
                <div class="menu_btn" @click="expand('kuoxie','扩写')">扩写
                </div>
                <div class="menu_btn" @click="expand('jianxie','简写')">简写</div>
                <div class="menu_btn line" @click="expand('xuxie','续写')">续写</div>
                <div class="menu_btn" @click="expand('jiangchong','降重')">降重<img class="hot_icon" src="./img/img_icon_97.png" alt=""></div>
                <div class="menu_btn" @click="expand('jiaodui','校对')">校对</div>
                <div class="menu_btn" @click="expand('runse','润色')">润色</div>
                <div class="menu_btn line" @click="expand('fanyi','翻译')">翻译</div>
                <!-- <div class="menu_btn" @click="expand('linggan','灵感')">灵感</div> -->
                <div class="menu_btn" @click="expand('draw','绘图')">绘图<img class="hot_icon" src="./img/img_icon_97.png" alt=""></div>
            </div>
        </div>
        <vipConfirm @confirm="confirmVip" v-show="vipVisible"></vipConfirm>
        <shareDoc ref="shareDoc"></shareDoc>
        <uploadDocVue ref="uploadDoc" @uploaded="upload"></uploadDocVue>
        <wordCharge ref="wordCharge"></wordCharge>
        <vipUpgrade @confirm="confirmVipUpgrade" v-show="vipUpgradeVisible"></vipUpgrade>
    </div>
</template>
<script type="text/ecmascript-6">
    import html2canvas from "html2canvas";
    import fetchRequest from "SRC/plugins/fetch.js"
    import quillEditorVue from "COMPONENTS/QuillEditor.vue"
    import vipConfirm from "COMPONENTS/VipConfirm.vue"
    import shareDoc from 'COMPONENTS/ShareDoc.vue'
    import uploadDocVue from 'COMPONENTS/UploadDoc.vue'
    import wordCharge from 'COMPONENTS/WordCharge.vue'
    import vipUpgrade from "COMPONENTS/VipUpgrade.vue"
    const Base64 = require('js-base64').Base64
    export default {
        components:{quillEditorVue,vipConfirm, shareDoc, uploadDocVue,wordCharge, vipUpgrade},
        data() {
            return {
                controller:null,
                type:this.$route.query.type||1,
                content:"",
                edit_content:"",
                menuShow:false,
                siteX:0,
                siteY:0,
                form:{
                    theme:"",
                    word_count:"",
                    lang:""
                },
                exam_list:[],
                write_count:0,
                exportTypeList:[
                    {name:"Word文档",type:"docx",icon:"29"},
                    {name:"图片格式",type:"img",icon:"45"},
                    // {name:"PDF格式文档",type:"pdf",icon:"46"},
                    {name:"TXT文档",type:"txt",icon:"47"},
                    // {name:"MarkDown格式文档",type:"markdown",icon:"48"},
                ],
                msgList:[],
                selectText:"",
                showSlide:false,
                quill:null,
                formList:[],
                saveTimer:null,
                autoSaving:false,
                cur_template_id:19,
                appTempalte:{},
                vipVisible:false,
                vipUpgradeVisible:false,
                cur_article_id:0,
                appTempalte:{},
                cur_article:{},
                question:"",
                startAutoSaveFlag:false, // 是否启动自动保存
                saveLoading:false,
                sendLoading:false, // 是否正在生成
                profileData:{},
                action_name:"干活",
                recent_doc_list:[
                ],
                base64Content:"",
                userInfo:{},
                ai_write_count:0,
                slideDefault:true,
                outpu_num:0, // 输出次数
                downloadImg:false,
                curAction:""
            }
        },
        created() {
            this.fetchProfile()
            this.cur_article = {}
            
            this.cur_article_id = this.$route.query.artid || 0
            this.cur_template_id = this.$route.query.tplid || 19
            this.fetchAppTempalte(this.cur_template_id)
            // this.startWrite()
            this.fetchProfileData()
            this.fetchArticleList()
            
        },
        computed:{
           
        },
        watch:{
            $route:{
                deep:true,
                handler(val){
                    this.cur_article = {}
                    let _cur_article_id = val.query.artid||0
                    this.cur_article_id = _cur_article_id
                    let _cur_template_id = val.query.tplid||19
                    this.cur_template_id = _cur_template_id
                    this.fetchAppTempalte(this.cur_template_id)
                    this.fetchProfile()
                    
                }
            }
        },
        mounted(){
            this.quill = this.$refs.quillEditor.quillEl;
        },
        methods: {
            fetchProfile(){
				this.$http.get('/front/aixz/profile/').then(res =>{
					if(res.status=='200'){
                        let  userInfo = res.data
                        this.userInfo = userInfo
                        if(this.cur_article_id==0){
                            this.content = this.edit_content = `<p><strong style=\"font-size: 24px;\">请在左侧录入框输入标题</strong></p><p><br></p><p>作者：${userInfo.nickname}</p><p><br></p><p>这里是Ai开始创作的地方</p>`
                            this.base64Content = Base64.encode(this.edit_content)
                        }
                        this.startWrite()
					}
				})
            },
            fetchArticleList(){
                // 最近文档
                this.$http.get(`/front/aixz/article/`,{params:{page_size:20}}).then(res =>{
                    if(res.status=='200'){
                        this.total =  res.data.total;
                        this.recent_doc_list = res.data.item_list.map(item=>{
                            item.show = false;
                            return item
                        })
                    }
                })
            },
            fetchProfileData(){
                this.$http.get('/front/aixz/profile/data/?id=').then(res =>{
                    if(res.status=='200'){
						this.profileData = res.data
                    }
                })
            },
            fetchAppTempalte(template_id){
                // 获取应用模板
                this.$http.get(`/front/aixz/app/template/${template_id}/`).then(res =>{
                    if(res.status=='200'){
                        this.appTempalte = res.data
                        this.formList = JSON.parse(res.data.form)
                        this.fetchArticle()
                        // this.fetchChatList("")
                    }
                })
                this.fetchDemoList(template_id)
            },
            fetchDemoList(template_id){
                // 获取应用模板示例
                this.$http.get(`/front/aixz/app/template/${template_id}/demo/`).then(res =>{
                    if(res.status=='200'){
                        this.exam_list = res.data
                    }
                })
            },
            useTemplateDemo(exam){
                if(JSON.parse(exam.form).length>0){
                    this.formList = JSON.parse(exam.form)
                }
            },
            fetchArticle(){
                // 获取文章内容
                if(!this.cur_article_id){
                    return
                }
                this.$http.get(`/front/aixz/article/${this.cur_article_id}/`).then(res =>{
                    if(res.status=='200'){
                        this.cur_article = res.data
                        if(JSON.parse(res.data.form).length>0)
                            this.formList = JSON.parse(res.data.form)
                        this.edit_content = this.cur_article.answer

                        let base64Content = Base64.encode(this.edit_content)
                        this.base64Content = base64Content

                        if(!this.startAutoSaveFlag){
                            this.startAutoSaveFlag = true
                            this.startWrite();
                        }
                    }
                })
            },
            async fetchChatList(action){
                // 获取对话记录
                await this.$http.get(`/front/aixz/chat/?article_id=${this.cur_article_id}&action=${action}`).then(res =>{
                    if(res.status=='200'){
                        this.msgList = res.data.item_list;
                    }
                })
            },
            resetForm() {
                // 重置表单数据
                this.formList.forEach(element => {
                    element.value = ""
                });
            },
            confirmVipUpgrade(val){
                this.vipUpgradeVisible = val.flag;
                if(val.action=="buy_words"){
                    this.$refs.wordCharge.show()
                }
            },
            confirmVip(val){
                this.vipVisible = val.flag;
                if(val.action=="buy_words"){
                    this.$refs.wordCharge.show()
                }
            },
            stopAiWrite(){
                // 停止书写
                this.saveLoading = false
                this.controller.abort();
                this.controller = null;
                this.sendLoading = false
            },
            submitForm() {
                this.outpu_num = 0
                // 开始写
                let row;
                this.formList.forEach(element => {
                    if(!element.value && !row){
                        row = element
                    }
                });

                if(row){
                    this.$message.error("请填写"+row.name);
                    return
                }
                let data = {
                    question:"",
                    template_id:this.cur_template_id,
                    form:this.formList,
                    company_id:0
                }
                let that = this
                this.saveLoading = true
                if(this.cur_article_id){
                    // 提交 chat
                    data.article_id = this.cur_article_id
                    data.answer = this.content
                    if(this.formList.length>0){
                        if( this.formList[0].is_title){
                            // 作为标题
                            data.question = this.formList[0].value
                        }
                    }

                    this.$http.put(`/front/aixz/article/${this.cur_article_id}/`, data).then(res =>{
                        if(res.status=='200'){
                            this.$http.post(`/front/aixz/chat/`, data).then(res =>{
                                let chat_id = res.data.chat_id
                                let score_balance = res.data.score_balance
                                if(score_balance==0){
                                    // 字数包用完
                                    this.saveLoading = false
                                    // this.$refs.wordCharge.show()
                                    this.vipVisible = true
                                    return
                                }
                                that.fetchStreamMsg(chat_id, "")
                                if(!this.startAutoSaveFlag){
                                    this.startAutoSaveFlag = true
                                    this.startWrite();
                                }
                            }).catch(res => {
                                this.$message({
                                    message: res.result,
                                    type: 'warning'
                                })
                            })
                        }
                    }).catch(res => {
                        this.$message({
                            message: res.result,
                            type: 'warning'
                        })
                    })
                    
                }else{
                    if(this.formList.length>0){
                        if( this.formList[0].is_title){
                            // 作为标题
                            data.question = this.formList[0].value
                            this.edit_content = this.content.replace("请在左侧录入框输入标题", data.question).replace("这里是Ai开始创作的地方", "\n")
                            data.answer = this.edit_content
                            this.cur_article.question = data.question
                        }
                    }
                    // this.quill.insertText(this.write_count,"\n");
                    this.$http.post(`/front/aixz/article/`, data).then(res =>{
                        if(res.status=='200'){
                            this.cur_article_id = res.data.article_id
                            let chat_id = res.data.chat_id
                            let score_balance = res.data.score_balance
                            if(score_balance==0){
                                // 字数包用完
                                this.saveLoading = false
                                // this.$refs.wordCharge.show()
                                this.vipVisible = true
                                return
                            }
                            this.fetchArticle()
                            
                            that.fetchStreamMsg(chat_id, "")
                            if(!this.startAutoSaveFlag){
                                this.startAutoSaveFlag = true
                                this.startWrite();
                            }
                        }
                    }).catch(res => {
                        this.$message({
                            message: res.result,
                            type: 'warning'
                        })
                    })
                }
            },
            fetchStreamMsg(chat_id, ctype){
                // 获取流式数据
                this.controller = fetchRequest('/api/front/aixz/chat/stream/',{chat_id:chat_id},(res,startFlag)=>{
					let lastMsg = {}
                    this.outpu_num += 1
					if(res == "JDYBLACK"){
						lastMsg.content = "智能AI机器人回答的的内容包含有违反中国法律法规的内容，请修改后重新提问！\n\n为了平台的健康绿色发展，请勿在平台内提问政治、色情相关的内容，感谢您的理解和支持！"
						this.$message({
                            message: lastMsg.content,
                            type: 'warning'
                        })
                        this.controller.abort();
						this.controller = null;
                        this.sendLoading = false
                        this.saveLoading = false

					}else if(res == "#end#"){
                        this.saveLoading = false
						this.controller = null;
                        this.sendLoading = false
                        if(ctype=="chat"){
                            let lastMsg = this.msgList[0];
                            lastMsg.loading = false
                        }else{
                            this.quill.insertText(this.write_count,"\n");
                        }
					}else{
                        this.ai_write_count += res.length
                        if(this.profileData.today_left_words - this.ai_write_count <=0){
                            // 字数用完
                            this.controller.abort();
						    this.controller = null;
                            this.sendLoading = false
                            this.saveLoading = false
                            this.vipVisible = true
                            this.$http.patch(`/front/aixz/profile/data/`,{action:"zeroword"}).then(res=>{})
                            return
                        }
                        this.sendLoading = true
						lastMsg.content += res;
                        if(ctype=="chat"){
                            let lastMsg = this.msgList[0];
                            lastMsg.answer += res;
                            lastMsg.loading = true
                        }else{
                            if(this.outpu_num == 1){
                                this.quill.insertText(this.write_count,"\n");
                            }
                            this.quill.insertText(this.write_count,res);
                            let scrollWrap = this.quill.container.querySelector(".ql-editor");
                            setTimeout(()=>{
                                scrollWrap.scrollTop = scrollWrap.scrollHeight;
                            },30)
                        }
					}
				});
            },
            startWrite(){
                if(this.saveTimer) clearInterval(this.saveTimer)
                this.saveTimer = setInterval(()=>{
                    this.autoSaving = true;
                    if(this.content){
                        let base64Content = Base64.encode(this.content)
                        if(this.base64Content != base64Content){
                            this.base64Content = base64Content
                            if(this.cur_article_id){
                                this.$http.put(`/front/aixz/article/${this.cur_article_id}/`, {answer:this.content, action:this.sendLoading?"aiwrite":""}).then(res =>{
                                    if(res.status=='200'){
                                        this.autoSaving = false
                                    }
                                }).catch(res => {
                                    clearInterval(this.saveTimer)
                                    this.$message({
                                        message: res.result,
                                        type: 'warning'
                                    })
                                })
                            }else{
                                let data = {
                                    answer:this.content,
                                    question:"",
                                    template_id:this.cur_template_id,
                                    form:this.formList,
                                    company_id:0,
                                    action:"autosave"
                                }
                                
                                this.$http.post(`/front/aixz/article/`, data).then(res =>{
                                    if(res.status=='200'){
                                        this.cur_article_id = res.data.article_id
                                        this.autoSaving = false
                                        this.fetchArticle()
                                    }
                                }).catch(res => {
                                    clearInterval(this.saveTimer)
                                    this.$message({
                                        message: res.result,
                                        type: 'warning'
                                    })
                                })
                            }
                        }else{
                            this.autoSaving = false
                        }
                    }else{
                        this.autoSaving = false
                    }
                   
                },2000)
            },
            richTextChange(content){
                this.content = content;
                this.write_count = this.quill.getLength() - 1;
            },
            changeToolBar(barName){
                // 工作栏按钮事件
                if(barName=="chat"){
                    this.slideDefault = true;
                    this.showSlide = true;
                    this.action_name = "干活"
                    // this.quill.insertText(this.content.length,"<img src='/static/img/img_icon_50.png'>");
                }
            },
            setFont(type){
                this.quill.format(type,true);
            },
            selectChange(e){
                let range =  this.quill.getSelection();
                if(range&&range.length){
                    let {index,length} = {...range};
                    this.selectRange = {index,length};
                    this.selectText = this.quill.getText(index, length);
                    let x = 0,y = 0;
                    if(window.getSelection){//ie不支持
                        let userSelection = window.getSelection();
                        let oRange = userSelection.getRangeAt(0); //get the text range 
                        let oRect = oRange.getBoundingClientRect(); 
                        x = oRect.left;
                        y = oRect.top;
                    }else{
                        x = e.clientX;
                        y = e.clientY;
                    }
                    let cw = document.body.clientWidth;
                    if(x + 637 > cw - 20){
                        x = cw - 20 - 637;
                    }
                    this.siteX = x;
                    this.siteY = y-36-30;
                    this.siteY = this.siteY < 114 ? 114 : this.siteY;
                    this.menuShow = true;
                }else{
                    this.menuShow = false;
                }
            },
            sendChatMsg(){
                // 对话
                if(!this.question){
                    this.$message.error("请输入指令内容");
                    return
                }
                let quote = ""
                if(this.msgList.length>0){
                    quote = this.msgList[0].quote
                }
                let msg = {id:0, question:this.question, quote:quote, answer:"",loading:true}
                this.msgList.unshift(msg)
                let data = {
                    question:msg.question,
                    chat_ask:msg.question,
                    quote:msg.quote,
                    article_id:this.cur_article_id,
                    action:this.curAction,
                    template_id:this.cur_template_id,
                    company_id:0
                }
                this.$http.post(`/front/aixz/chat/`, data).then(res =>{
                    if(res.status=='200'){
                        let score_balance = res.data.score_balance
                        if(score_balance==0){
                            // 字数包用完
                            // this.$refs.wordCharge.show()
                            this.vipVisible = true
                            return
                        }
                        let chat_id = res.data.chat_id
                        this.msgList[0].id = chat_id
                        this.fetchStreamMsg(chat_id, 'chat')
                    }else{
                        this.msgList[0].answer = res.message
                    }
                }).catch(res => {
                    this.msgList[0].answer = res.result
                    this.msgList[0].loading = false
                })
            },
            async expand(action, action_name){
                // 获取对话记录
                if(this.sendLoading){
                    this.$message({
                        message: '正在生成中，请稍后再试',
                        type: 'warning',
                        duration:1500
                    });
                    return
                }
                this.curAction = action
                await this.fetchChatList(action)
                this.action_name = action_name
                let range = this.quill.getSelection(true)
                let delta = this.quill.getContents(range.index, range.length) // 获取选中的内容
                let selectTxt = delta.ops.length>0?delta.ops[0].insert:""

                if((action == "fenxi"||action == "keypoint"||action == "wenti")&&!this.cur_article.id){
                    this.$message({
                        message: '请先进行内容创作',
                        type: 'warning',
                        duration:1500
                    });
                    return
                }
                if(action == "draw"){

                }else if(this.userInfo.is_vip==0 && (action == "gaixie")){
                    // 有权限
                }else if(this.userInfo.is_vip==1 && this.userInfo.vip_type>=1 && (action == "wenti" || action == "kuoxie" || action == "gaixie" || action == "gaixie_gw" || action == "jianxie" || action == "xuxie" || action == "jiangchong" || action == "runse" || action == "fanyi" || action == "jiaodui")){
                    // 有权限
                }else if(this.userInfo.is_vip==1 && this.userInfo.vip_type>=2 && (action == "keypoint" || action == "gaixie_ql")){
                    // 有权限
                }else if(this.userInfo.is_vip==1 && this.userInfo.vip_type>=3 && (action == "fenxi" || action == "gaixie_xs")){
                    // 有权限
                }else{
                    this.vipUpgradeVisible = true
                    return
                }
                let msg = {id:0, question:"", quote:"", answer:"", loading:true}
                
                if(action == "kuoxie"){
                    msg.question = "扩写"
                    msg.quote = selectTxt
                }else if(action == "gaixie"){
                    msg.question = "改写"
                    msg.quote = selectTxt
                }else if(action == "gaixie_ql"){
                    msg.question = "改写"
                    msg.quote = selectTxt
                }else if(action == "gaixie_xs"){
                    msg.question = "改写"
                    msg.quote = selectTxt
                }else if(action == "gaixie_gw"){
                    msg.question = "改写"
                    msg.quote = selectTxt
                }else if(action == "jianxie"){
                    msg.question = "简写"
                    msg.quote = selectTxt
                }else if(action == "xuxie"){
                    msg.question = "续写"
                    msg.quote = selectTxt
                }else if(action == "fenxi"){
                    msg.question = "帮我进行全文分析"
                    msg.quote = ""

                    
                }else if(action == "keypoint"){
                    msg.question = "提取核心观点"
                    msg.quote = ""
                }else if(action == "wenti"){
                    msg.question = "提出相关问题"
                    msg.quote = ""
                }else if(action == "jiangchong"){
                    msg.question = "降重"
                    msg.quote = selectTxt
                }else if(action == "jiaodui"){
                    msg.question = "校对"
                    msg.quote = selectTxt
                }else if(action == "runse"){
                    msg.question = "润色"
                    msg.quote = selectTxt
                }else if(action == "fanyi"){
                    msg.question = "翻译"
                    msg.quote = selectTxt
                }else if(action == "draw"){
                    this.$refs.quillEditor.aiShow(selectTxt);
                    return
                }else{
                    selectTxt = ""
                }
                this.msgList.unshift(msg)
                let data = {
                    question:msg.question,
                    quote:selectTxt,
                    article_id:this.cur_article_id,
                    action:action,
                    template_id:this.cur_template_id,
                    company_id:0
                }
                if(this.cur_article_id){
                    
                    this.$http.post(`/front/aixz/chat/`, data).then(res =>{
                        let chat_id = res.data.chat_id
                        let score_balance = res.data.score_balance
                        if(score_balance==0){
                            // 字数包用完
                            this.saveLoading = false
                            // this.$refs.wordCharge.show()
                            this.vipVisible = true
                            return
                        }
                        this.msgList[0].id = chat_id
                        this.fetchStreamMsg(chat_id, 'chat')
                    }).catch(res => {
                        this.$message({
                            message: res.result,
                            type: 'warning'
                        })
                    })
                }else{
                    data.answer = this.content
                    this.$http.post(`/front/aixz/article/`, data).then(res =>{
                        if(res.status=='200'){
                            this.cur_article_id = res.data.article_id
                            data.article_id = this.cur_article_id
                            // let chat_id = res.data.chat_id
                            // this.msgList[0].id = chat_id
                            let score_balance = res.data.score_balance
                            if(score_balance==0){
                                    // 字数包用完
                                this.saveLoading = false
                                // this.$refs.wordCharge.show()
                                this.vipVisible = true
                                return
                            }

                            this.$http.post(`/front/aixz/chat/`, data).then(res =>{
                                let chat_id = res.data.chat_id
                                this.msgList[0].id = chat_id
                                this.fetchStreamMsg(chat_id, 'chat')
                            })
                        }
                    }).catch(res => {
                        this.$message({
                            message: res.result,
                            type: 'warning'
                        })
                    })
                }
                // this.quill.format('color', '#07c160');
                this.slideDefault = false;
                if(this.showSlide){
                    this.showSlide = false;
                    setTimeout(()=>{
                        this.showSlide = true;
                    },300)
                }else{
                    this.showSlide = true;
                }
                this.menuShow = false;
            },
            copyArticle(){
                this.copytext(this.quill.getText());
            },
            copytext (text) {
                const el = document.createElement('textarea')
                el.setAttribute('readonly', 'readonly')
                el.style.position = 'absolute'
                el.style.left = '-9999px'
                el.value = text
                document.body.appendChild(el)
                el.select()
                document.execCommand('copy')
                document.body.removeChild(el)
                this.$toast("复制成功");
            },
			stopReply(msg){
				try{
					this.controller.abort();
					this.sendLoading = false;
					this.controller = null;
                    msg.loading = false
                    if(!msg.answer) msg.answer = "您已停止接收回复~"
				}catch(e){}
			},
            replaceSelect(content){
                if(this.selectRange){
                    this.quill.deleteText(this.selectRange.index,this.selectRange.length);
                    this.quill.insertText(this.selectRange.index,content)
                }
            },
            insertAfter(content){
                let range =  this.quill.getSelection();
                let index = range?range.index+range.length:this.content.length
                this.quill.insertText(index,"\n");
                index += 2
                this.quill.insertText(index,content);
            },
            showSlideDefault(){
                this.slideDefault = true
            },
            closeSlide(){
                if(this.selectRange&&this.selectRange.index){
                    let selectionStyle = this.quill.getFormat(this.selectRange.index,this.selectRange.length);
                    if(selectionStyle.color == "#07c160"){
                        this.quill.removeFormat(this.selectRange.index,this.selectRange.length);
                    }
                    this.selectRange = {};
                }
                this.showSlide = false;
                this.menuShow = false;
            },
            showUpload(){
                this.$refs.uploadDoc.show();
            },
            upload(data){
                this.$refs.uploadDoc.close();
                this.$router.push(`/essaywriting?tplid=${data.template_id}&artid=${data.art_id}`)
            },
            showShare(){
                if(!this.cur_article.id){
                    this.$message({
                        message: '请先进行内容创作',
                        type: 'warning',
                        duration:1500
                    });
                    return
                }
                this.$refs.shareDoc.show(this.cur_article.id);
            },
            doActionRow(action){
                // 单行操作
                let value
                if(action=="star"&&this.cur_article.id){
                    value = this.cur_article.is_star ? 0:1
                    this.$http.patch(`/front/aixz/article/${this.cur_article.id}/`,{action:action, value:value}).then(res =>{
                        if(res.status=='200'){
                            this.$message({
                                message: '操作成功',
                                type: 'success',
                                duration:1500
                            });
                            this.fetchArticleList()
                        }
                    })
                }
                if(action=="star"&!this.cur_article.id){
                    this.$message({
                        message: '请先进行内容创作',
                        type: 'warning',
                        duration:1500
                    });
                }
            },
            selectDoc(row){
                let url = '/essaywriting?tplid='+row.template_id+'&artid='+row.id
                if(row.template_id ==27){
                    url = '/longwriting?tplid='+row.template_id+'&artid='+row.id
                }
                this.$router.push(url);
            },
            fileExport(action){
                if(!this.cur_article.id){
                    this.$message({
                        message: '请先进行内容创作',
                        type: 'warning',
                        duration:1500
                    });
                }
                if(this.userInfo.is_vip==0 && action=="docx"){
                    // 有权限
                }else if(this.userInfo.is_vip==1 && this.userInfo.vip_type>=1){
                    // 有权限
                }else{
                    this.vipUpgradeVisible = true
                    return
                }

                if(action == "img"){
                    if(!this.downloadImg){
                        this.downloadImg = true;
                        let imgWrap = this.quill.container.querySelector(".ql-editor");
                        html2canvas(imgWrap,{
                            useCORS: true,
                            windowHeight: 5000,
                            width: imgWrap.scrollWidth,
                            height: imgWrap.scrollHeight
                        }).then((canvas)=>{
                            let link = document.createElement('a');
                            //图片转成base64格式
                            link.href = canvas.toDataURL("image/png");
                            link.download = this.cur_article.question;
                            link.click();
                            this.downloadImg = false;
                        })
                    }else{
                        this.$toast("图片正在下载中，请稍后...")
                    }
                }else{
                    let t = Date.now()
                    let downloadUrl = API_SERVER+'/api/front/aixz/article/export/?art_id='+this.cur_article.id+"&action="+action + "&t="+t
                    this.downloadExcel(downloadUrl, `${this.cur_article.question}.${action}`);
                }
            },
            getRecord(action, action_name){
                this.curAction = action
                if(!this.cur_article.id){
                    this.$message({
                        message: '请先进行内容创作',
                        type: 'warning',
                        duration:1500
                    });
                    return
                }
                this.slideDefault = false;
                this.action_name = action_name;
                this.fetchChatList(action)
            }
        },
        beforeDestroy(){
            if(this.saveTimer) clearInterval(this.saveTimer);
            if(this.controller) this.controller.abort();
        }
    };
</script>
<style rel="stylesheet/scss" lang="scss" scoped>
    #Essaywriting{
        width: 100%;
        height: 100%;
        display: flex;
        padding: 0 20px;
        min-width: 1240px;
        .form_part{
            width: 380px;
            flex-shrink: 0;
            display: flex;
            flex-direction: column;
            overflow: hidden;
            >>> .el-form-item__label{line-height: 20px;}
            .part_top{
                height: 54px;
                line-height: 54px;
                .top_icon{
                    width: 16px;
                    margin-right: 6px;
                    vertical-align: middle;
                    margin-top: -2px;
                }
            }
            .part_content{
                flex-grow: 1;
                >>> .el-form-item__content{margin-right: 2px;margin-left: 0px;}
                >>> .el-form-item__label{padding: 0;line-height: 40px;text-align:left;}
                >>> .el-textarea__inner{border: 1px solid #EEEEEE; border-radius:2px;}
                >>> .el-input__inner{border: 1px solid #EEEEEE; border-radius:2px;}
                .write_icon{
                    width: 18px;
                    margin-right: 12px;
                    vertical-align: middle;
                    margin-top: -2px;
                }
                .writing_wrap{
                    float:right;
                    width:220px;
                }
                .writing_btn{
                    width: 100%;
                    margin: 0 auto;
                    height:40px;
                    border-radius: 4px;
                    box-shadow: 0 0 10px 0 rgba(7,193,96,0.8);
                    padding: 0 15px;
                    display: flex;
                    align-items: center;
                    background-color: #ecffec;
                    .writing_icon{
                        margin-right: 8px;
                        flex-shrink: 0;
                    }
                    .writing_text{
                        flex-grow: 1;
                        color: #07c160;
                        white-space: nowrap;
                        overflow: hidden;
                    }
                    .stop_icon{
                        display: block;
                        width: 18px;
                        height: 18px;
                        flex-shrink: 0;
                        cursor: pointer;
                    }
                }
                .example_part{
                    .example_title{
                        display: flex;
                        justify-content: space-between;
                        line-height: 40px;
                        .title_text{
                            border-bottom: 1px dashed #999;
                        }
                        .get_vip{
                            color: #999;
                            border-bottom: 1px dashed #ccc;
                            display: flex;
                            align-items: center;
                            cursor: pointer;
                            width: 220px;
                            .vip_icon{
                                width: 16px;
                                margin-right: 10px;
                            }
                            .vip_text{
                                flex-grow: 1;
                            }
                            .more_icon{
                                width: 22px;
                            }
                        }
                    }
                    .example_list{
                        .list_item{
                            color: #999;
                            border-bottom: 1px dashed #ccc;
                            line-height: 60px;
                            padding-left: 14px;
                            position: relative;
                            padding-right: 20px;
                            overflow: hidden;
                            white-space: nowrap;
                            text-overflow: ellipsis;
                            &:hover{
                                .use_icon{
                                    display: block;
                                }
                            }
                            &::before{
                                content: "";
                                display: block;
                                width: 4px;
                                height: 4px;
                                border-radius: 2px;
                                background-color: #999;
                                position: absolute;
                                top: 28px;
                                left: 0;
                            }
                            .use_icon{
                                position: absolute;
                                width: 20px;
                                height: 20px;
                                top: 20px;
                                right: 0;
                                display: none;
                                cursor: pointer;
                            }
                        }
                    }
                }
            }
        }
        .edit_part{
            flex-grow: 1;
            display: flex;
            flex-direction: column;
            .part_top{
                height: 54px;
                line-height: 54px;
                display: flex;
                .write_title{
                    width: 190px;
                    white-space: nowrap;
                    overflow: hidden;
                    text-overflow: ellipsis;
                    padding-right: 12px;
                    flex-shrink: 0;
                }
                .auto_save{
                    flex-grow: 1;
                    color: #999;
                }
                .top_tool{
                    display: flex;
                    align-items: center;
                    .tool_btn{
                        padding: 3px;
                        border-radius: 3px;
                        cursor: pointer;
                        &:hover{
                            background-color: #ddd;
                        }
                        &:not(:last-child){
                            margin-right: 26px;
                        }
                        .btn_icon{
                            display: block;
                            width: 16px;
                        }
                    }
                }
                .top_icon{
                    width: 16px;
                    margin-right: 6px;
                    vertical-align: middle;
                    margin-top: -2px;
                }
            }
            .editor_wrapper{
                background-color: #fff;
                flex-grow: 1;
                position: relative;
                overflow: hidden;
                .editor_slider{
                    position: absolute;
                    width: 420px;
                    right: 0;
                    top: 59px;
                    bottom: 1px;
                    background-color: #fff;
                    box-shadow: -3px 0 10px -3px #ddd;
                    display: flex;
                    flex-direction: column;
                    overflow: hidden;
                    .slider_top{
                        height: 110px;
                        background-image: url("./img/img_icon_49.png");
                        padding: 0 20px;
                        flex-shrink: 0;
                        &.default_top{
                            height: 160px;
                            background-image: url("./img/img_icon_105.png");
                            position: relative;
                            padding-top: 30px;
                            font-size: 13px;
                            color: #000;
                            text-align: center;
                            .close_icon{
                                right: 20px;
                            }
                            .logo_icon{
                                width: 42px;
                                display: block;
                                margin: 0 auto;
                            }
                            .default_title{
                                padding-top: 10px;
                                line-height: 32px;
                                font-weight: bold;
                            }
                            .default_desc{
                                color: #ccc;
                                line-height: 32px;
                            }
                        }
                        .slider_title{
                            position: relative;
                            height: 50px;
                            display: flex;
                            align-items: center;
                            .logo_icon{
                                width: 20px;
                                margin-right: 6px;
                            }
                            .title_text{
                                background-image: linear-gradient(to right, #4a5ff7, #ec2fe3);
                                background-clip: text;
                                color: transparent;
                                -webkit-text-fill-color: transparent;
                                cursor: pointer;
                            }
                        }
                        .close_icon{
                            position: absolute;
                            width: 16px;
                            cursor: pointer;
                            display: block;
                            top: 17px;
                            right: 0;
                        }
                        .top_input{
                            height: 40px;
                            border-radius: 3px;
                            border: 1px solid #ddd;
                            padding: 0 12px;
                            margin-bottom: 15px;
                            display: flex;
                            align-items: center;
                            background-color: #fff;
                            
                            .input_ele{
                                flex-grow: 1;
                                height: 100%;
                                background-color: transparent;
                                border: none;
                                font-size: 12px;
                            }
                            .send_icon{
                                width: 16px;
                                cursor: pointer;
                                display: block;
                            }
                        }
                    }
                    .slide_content{
                        flex-grow: 1;
                        overflow: hidden;
                        &.default_content{
                            padding: 0 30px;
                        }
                        .msg_list{
                            padding: 0 20px;
                            .msg_item{
                                padding: 20px 0;
                                border-bottom: 1px dashed #ccc;
                                &:last-child{
                                    border-bottom: none;
                                }
                                .msg_source{
                                    display: flex;
                                    margin-bottom: 12px;
                                    .source_main{
                                        flex-grow: 1;
                                        display: flex;
                                        flex-direction: column;
                                        align-items: flex-end;
                                        margin-right: 12px;
                                        .msg_desc{
                                            padding: 3px 10px;
                                            background-color: #eee;
                                            border-radius: 3px;
                                            line-height: 24px;
                                            position: relative;
                                            margin-bottom: 4px;
                                            &::after{
                                                content: "";
                                                display: block;
                                                border: 5px solid transparent;
                                                border-left-color: #eee;
                                                position: absolute;
                                                top: 50%;
                                                margin-top: -5px;
                                                right: -10px;
                                            }
                                        }
                                        .msg_quote{
                                            background-color: #f5f5f5;
                                            padding: 3px 10px 3px 20px;
                                            position: relative;
                                            font-size: 12px;
                                            line-height: 20px;
                                            max-height: 52px;
                                            text-overflow: ellipsis;
                                            overflow: hidden;
                                            display: -webkit-box;
                                            -webkit-box-orient: vertical;
                                            -webkit-line-clamp: 2;
                                            color: #ccc;
                                            &::before{
                                                content: "";
                                                position: absolute;
                                                display: block;
                                                height: 100%;
                                                width: 10px;
                                                left: 0;
                                                top: 0;
                                                background-color: #eee;
                                            }
                                        }
                                    }
                                    .msg_head{
                                        width: 30px;
                                        height: 30px;
                                        border-radius: 15px;
                                        display: flex;
                                        align-items: center;
                                        justify-content: center;
                                        flex-shrink: 0;
                                        .head_img{
                                            width: 20px;
                                            display: block;
                                        }
                                    }
                                }
                                .msg_content{
                                    margin-bottom: 18px;
                                    line-height: 24px;
                                    white-space: pre-line;
                                    .tip_loading{
                                        display: flex;
                                        vertical-align: middle;
                                        .ai_loading{
                                            height: 20px;
                                            margin: 1px 4px 0 0;
                                        }
                                    }
                                }
                                .msg_operation{
                                    display: flex;
                                    justify-content: space-between;
                                    .msg_btn{
                                        padding: 0 13px;
                                        height: 30px;
                                        border-radius: 3px;
                                        background-color: #eee;
                                        font-size: 12px;
                                        border: 1px solid #e3e3e3;
                                        background-color: transparent;
                                        color: #424242;
                                        &:disabled{
                                            opacity: 0.6;
                                        }
                                        .btn_icon{
                                            width: 14px;
                                            vertical-align: middle;
                                            margin: -3px 10px 0 0;
                                        }
                                    }
                                }
                            }
                        }
                        .empty_msg{
                            padding-top: 110px;
                            text-align: center;
                            .empty_icon{
                                display: block;
                                width: 130px;
                                margin: 0 auto 40px;
                            }
                            .empty_text{
                                color: #ccc;
                            }
                        }
                        .content_tips{
                            padding-top: 24px;
                            line-height: 17px;
                            text-align: center;
                            .tips_text{
                                color: #ccc;
                                padding: 0 16px;
                                position: relative;
                                &::before,&::after{
                                    content: "";
                                    position: absolute;
                                    display: block;
                                    width: 70px;
                                    height: 1px;
                                    top: 7px;
                                }
                                &::before{
                                    background-image: linear-gradient(to right,#fff,#ccc);
                                    left: -70px;
                                }
                                &::after{
                                    background-image: linear-gradient(to right,#ccc,#fff);
                                    right: -70px;
                                }
                            }
                        }
                        .type_list{
                            display: flex;
                            justify-content: space-between;
                            border-bottom: 1px dashed #ccc;
                        }
                        .type_line_two{
                            padding-top: 6px;
                            display: flex;
                            .type_item{
                                margin-right: 20px;
                            }
                        }
                        .type_item{
                            cursor: pointer;
                            line-height: 84px;
                        }
                    }
                }
            }
            .part_footer{
                height: 66px;
                padding: 0 20px;
                display: flex;
                align-items: center;
                background-color: #fff;
                border-left: 1px solid #dcdfe6;
                border-right: 1px solid #dcdfe6;
                .count_info{
                    flex-grow: 1;
                    .word_count{
                        font-size: 13px;
                        line-height: 23px;
                    }
                    .left_count{
                        font-size: 12px;
                        line-height: 22px;
                        color: #999;
                    }
                }
                .footer_btns{
                    .btn_item{
                        padding: 0 14px;
                        height: 36px;
                        border: 1px solid #e5e5e5;
                        border-radius: 3px;
                        background-color: transparent;
                        font-size: 14px;
                        margin-right: 16px;
                        &:last-child{
                            margin-right: 0;
                        }
                        &.active{
                            background-color: #07c160;
                            color: #fff;
                            border-color: #07c160;
                        }
                        .btn_icon{
                            width: 16px;
                            vertical-align: middle;
                            margin: -3px 10px 0 0;
                            &.down_icon{
                                margin-top: -2px;
                                margin-right: 0;
                            }
                        }
                        .split_line{
                            display: inline-block;
                            vertical-align: middle;
                            height: 20px;
                            border-right: 1px solid #ccc;
                            margin: -3px 10px 0 16px;
                        }
                    }
                }
            }
            .selection_menu{
                position: fixed;
                height: 48px;
                padding: 0 12px;
                min-width: 670px;
                display: flex;
                box-shadow: 0 0 8px 0px #dadada;
                border-radius: 8px;
                background-color: #fff;
                flex-wrap: nowrap;
                align-items: center;
                &::after{
                    content: "";
                    display: block;
                    position: absolute;
                    border: 6px solid transparent;
                    border-top-color: #fff;
                    left: 100px;
                    bottom: -12px;
                }
                .menu_btn{
                    padding: 0 11px;
                    font-size: 14px;
                    line-height: 20px;
                    cursor: pointer;
                    position: relative;
                    &:hover{
                        color: #06c;
                        .ql-stroke,.ql-thin,.ql-fill{
                            color: #06c;
                            stroke: #06c;
                        }
                    }
                    &.expand{
                        height: 48px;
                        line-height: 48px;
                        &:hover{
                            .slide_wrap{
                                display: block;
                            }
                        }
                        .hot_icon{
                            top: 6px;
                            right: 16px;
                        }
                        .slide_wrap{
                            display: none;
                            position: absolute;
                            width: 100%;
                            left: 0;
                            top: 49px;
                            background-color: #fff;
                            box-shadow: 0 0 8px 0px #dadada;
                            .slide_item{
                                line-height: 30px;
                                padding: 0 15px;
                                color: #424242;
                                cursor: pointer;
                                &:hover{
                                    background-color: #eee;
                                }
                            }
                        }
                    }
                    .hot_icon{
                        position: absolute;
                        top: -8px;
                        right: -2px;
                        display: block;
                        width: 16px;
                    }
                    .slide_icon{
                        vertical-align: middle;
                        width: 10px;
                        margin: -2px 0 0 8px;
                    }
                    svg{
                        height: 18px;
                        font-size: 18px;
                        display: block;
                    }
                    .ql-stroke.ql-thin {
                        stroke-width: 1;
                    }
                    .ql-stroke {
                        fill: none;
                        stroke: #444;
                        stroke-linecap: round;
                        stroke-linejoin: round;
                        stroke-width: 2;
                    }
                    .ql-fill{
                        fill: #444;
                    }
                }
                .line{
                    height: 20px;
                    border-right: 1px solid #e7e7eb;
                }
            }
        }
    }
    .dropdown_list{
        padding: 0 15px;
        .dropdown_item{
            height: 48px;
            border-bottom: 1px dashed #ccc;
            font-size: 12px;
            display: flex;
            align-items: center;
            cursor: pointer;
            &:last-child{
                border-bottom: none;
            }
            &:hover{
                color: #07c160;
            }
            img{
                width: 16px;
                display: block;
                margin-right: 10px;
                margin-top: -2px;
            }
        }
    }
    .doc_panel{
        padding: 0 20px 8px;
        .doc_panel_title{
            line-height: 50px;
            border-bottom: 1px solid #ddd;
        }
        .doc_name{
            text-overflow: ellipsis;
            overflow: hidden;
            .doc_icon{
                width: 16px;
                margin: -2px 12px 0 0;
                vertical-align: middle;
            }
        }
        .doc_create_name{
            padding-left: 28px;
            color: #999;
            font-size: 12px;
        }
    }
    .slide-enter-active, .slide-leave-active {
        transition: all .5s;
    }
    .slide-enter, .slide-leave-to {
        transform: translateX(100%);
    }
    .spread-enter-active{
        transition: all 1s linear;
        .writing_btn{
            transition: all 1s linear;
        }
    }
    .spread-leave-active{
        display: none;
    }
    .spread-enter{
        .writing_btn{
            width: 71px!important;
        }
    }
</style>